import { Box, SxProps, Theme } from '@mui/material';
import { memo, ReactNode } from 'react';

interface ICustomBoxProps {
  title: ReactNode | string;
  onClick?: () => void;
  type?: 'span';
  decoration?: string;
  typography?: string;
  color?: string;
  sx?: SxProps<Theme>;
}
function CustomBox({
  title,
  type = 'span',
  onClick,
  typography = 's14w400',
  decoration = 'none',
  color = 'mind.black.A10',
  ...props
}: ICustomBoxProps): JSX.Element {
  return (
    <Box
      component={type}
      onClick={onClick}
      sx={{ color, typography, textDecoration: decoration, cursor: 'pointer', ...props?.sx }}
    >
      {title}
    </Box>
  );
}

export default memo(CustomBox);
